import React, { type JSX } from 'react';

import {
    Table,
    TableBody,
    TableCell,
    TableRow,
} from '@mui/material';
import { ErrorBoundary } from 'common/hocs/ErrorBoundary';

type TableWrapperProps = {
    children?: React.ReactNode
};

export function TableWrapper({ children }: Readonly<TableWrapperProps>): JSX.Element {
    return (
        <Table>
            <TableBody>
                <ErrorBoundary>
                    <TableRow sx={{ '& td': { border: 0 } }}>
                        <TableCell align="left"></TableCell>
                        <TableCell align="right" sx={{ paddingRight: 0 }}>
                            {children}
                        </TableCell>
                    </TableRow>
                </ErrorBoundary>
            </TableBody>
        </Table>
    );
}
